module.exports = __webpack_public_path__ + "static/media/product-commerce.49fd1bd9.svg";